import React from "react";
import styles from './styles.module.scss';

export const IntegrationTitle = ({ title }) => {
    return (
        <div className={styles.title}>{title}</div>
    )
};